import * as React from 'react';
import config from '../../../config';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PrintIcon from '@mui/icons-material/Print';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import AddIcon from '@mui/icons-material/Add'
import EditWorkorder from "./editworkorderData";
import AddWorkorder from "./addworkorderData"
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useCallback } from 'react';
import { getMyWorkorderPaginated, UpdateSimulateWorkorder } from '../../../REST/workorders';
import { createWorkorderLink } from "../../../helpers"
import moment from 'moment';
import ServerDataGrid from '../../../Components/ServerDataGrid';
import PageShell from '../../../themes/components/PageShell';
import PageHeader from '../../../themes/components/PageHeader';
import PageContent from '../../../themes/components/PageContent';
import Action from '../../../themes/components/Action';



export default function WorkorderList(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [add, setAdd] = useState(null);
    const [edit, setEdit] = useState(null);
    const [refresh, setRefresh] = React.useState(false);

    const id = location.pathname.replace("/workorder/workorderList/", "")

    const handlePrint = (params) => {
        const id = params.row._id
        let link = config.REACT_APP_API_URL + "/api/Workorder/print/" + id

        window.open(link, "_blank")
    }
    const handleEdit = (params) => {
        setEdit(params.row._id)

    }
    const handleCloseEdit = (ret) => {
        setEdit(null)
        if (ret) setRefresh()
    }
    const handleView = (params) => {
        const inspectionId = params.row._id
        const link = createWorkorderLink(inspectionId, true)
        window.open(link, "_blank")
    }
    const handleComplete = (params) => {
        UpdateSimulateWorkorder(params.row._id, { status: "Completed" })
            .then(() => {
                setRefresh(!refresh)
            })
    }
    const columns = [
        {
            field: "_id",
            headerName: "Action",
            width: 150,
            minVisible: 'xs',
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <>
                        <IconButton title={"View Workorder"}
                            onClick={(evt) => { evt.preventDefault(); handleView(params) }} >
                            <ContentPasteGoIcon style={{ fontSize: 16 }} />
                        </IconButton>
                        <IconButton title={"Print Workorder"} onClick={(evt) => { evt.preventDefault(); handlePrint(params) }} >
                            <PrintIcon  ></PrintIcon>
                        </IconButton>

                        {
                            params.row.status !== "Completed" && <IconButton title={"Edit Workorder"}
                                onClick={(evt) => { evt.preventDefault(); handleEdit(params) }} ><EditIcon style={{ fontSize: 16 }} /></IconButton>

                        }
                        {
                            params.row.status !== "Completed" &&
                            <IconButton title={"Complete Workorder"}
                                onClick={(evt) => { evt.preventDefault(); handleComplete(params) }} ><DoneAllIcon style={{ fontSize: 16 }} /></IconButton>

                        }
                    </>
                )
            }
        },
        { field: "workordertype", headerName: "Workorder Type", flex: 1, minVisible: 'md' },
        { field: "refnumber", headerName: "Workorder Ref Number", flex: 1, minVisible: 'xs' },
        { field: "status", headerName: "Workorder Status", flex: 1, type: 'singleSelect', valueOptions: ['Created', 'In Progress', 'Completed'], minVisible: 'md' },
        { field: "name", headerName: "Tenant Name", flex: 1, minVisible: 'xs' },
        { field: "email", headerName: "Tenant Email", flex: 1, minVisible: 'md' },
        {
            field: 'createdAt',
            headerName: 'Created On',
            flex: 1,
            minVisible: 'md',
            valueFormatter: (params) => moment(params.value).format("MM/DD/YYYY HH:mm")
        }
    ];

    const fetchWorkorders = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await getMyWorkorderPaginated(id, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [id, refresh]);

    const handleCloseAdd = (ret) => {
        setAdd(null)
        if (ret) setRefresh(!refresh)
    }

    return (
        <PageShell>
            <PageHeader
                title="Workorders"
                back
                onBack={() => navigate(-1)}
                actions={
                    <Action
                        primary
                        icon={<AddIcon />}
                        label="Add New Workorder"
                        onClick={() => setAdd(id)}
                    />
                }
            />
            <PageContent fill>
                <div style={{ height: '100%' }}>
                    <ServerDataGrid
                        columns={columns}
                        fetchData={fetchWorkorders}
                        initialPageSize={10}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        getRowId={(row) => row._id}
                    />
                </div>
            </PageContent>
            {edit !== null && <EditWorkorder id={edit} handleClose={handleCloseEdit} />}
            {add !== null && <AddWorkorder id={add} handleClose={handleCloseAdd} />}
        </PageShell>
    );
}
